import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.757 3.344A4.2 4.2 0 0 0 10 2.292c-1.147 0-2.255.485-3.08 1.364S5.625 5.74 5.625 7c0 3.197-.643 5.296-1.318 6.618q-.225.433-.441.757h12.268a8 8 0 0 1-.44-.757c-.659-1.288-1.286-3.315-1.318-6.377l1.138-1.421q.11.58.111 1.18c0 3.025.607 4.926 1.181 6.049.288.562.57.936.77 1.16a3 3 0 0 0 .285.28l.007.006a.625.625 0 0 1-.368 1.13h-15a.625.625 0 0 1-.368-1.13l.007-.006.053-.045c.05-.045.131-.121.231-.234.2-.226.483-.599.77-1.161.575-1.123 1.182-3.024 1.182-6.049 0-1.568.584-3.079 1.634-4.199C7.059 1.68 8.495 1.041 10 1.041c1.293 0 2.534.471 3.524 1.314zM9.099 17.186a.625.625 0 1 0-1.081.628 2.292 2.292 0 0 0 3.964 0 .625.625 0 1 0-1.08-.628 1.042 1.042 0 0 1-1.803 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.544 4.293a.625.625 0 0 1 .883 0l1.225 1.225 2.892-3.725a.625.625 0 0 1 .883.884l-3.333 4.167a.625.625 0 0 1-.884 0l-1.667-1.667a.625.625 0 0 1 0-.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }